export const appConstant = {
    SHOW_LOADING: "SHOW_LOADING",
    HIDE_LOADING: "HIDE_LOADING",
    SHOW_MESSAGE: "SHOW_MESSAGE",
    HIDE_MESSAGE: "HIDE_MESSAGE",
};
